import { Status } from "@application/hooks/use_action_cable_subscription";

// At most one run in flight. Calls that land meanwhile get exactly one run
// after it, so the last update is never dropped.
export const coalesce = (run: () => Promise<unknown>) => {
  let running = false;
  let again = false;
  const request = (): void => {
    if (running) {
      again = true;
      return;
    }
    running = true;
    const done = () => {
      running = false;
      if (!again) return;
      again = false;
      request();
    };
    // A failed run shows on the query's own error; the next update retries.
    run().then(done, done);
  };
  return request;
};

// The version of each message a thread last fetched. An update naming one
// already held would bring back the same bytes. One without a version (a tool
// call starting or returning) always fetches.
export const heldVersions = () => {
  const held = new Map<string, string>();
  return {
    holds: (messageId: string, version: string | undefined): boolean =>
      version != null && (held.get(messageId) ?? "") >= version,
    hold: (messageId: string, version: string | undefined) => {
      if (version != null) held.set(messageId, version);
    },
  };
};

// True when the channel comes back after a drop: updates may have been missed.
// The first connect follows the thread's own load, so it's false.
export const reconnected = () => {
  let connected = false;
  return (status: Status | undefined): boolean => {
    if (status !== Status.Connected) return false;
    const again = connected;
    connected = true;
    return again;
  };
};
